import gql from 'graphql-tag';
export default gql`
  fragment correctedSalesReportInfo on CorrectedSalesReport {
    correctedTotal
    correctedTotalWithPDV
    correctedCount
  }
`;